import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { IDocument, IDocument_locname, PatientTeleDoc } from 'src/app/models/IDocument';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { MatPaginator, MatDialog, MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DocumentService } from 'src/app/Services/Documents/document.service';
import { DatePipe, formatDate } from '@angular/common';
import { DeleteDocumentComponent, ConfirmDialogModel } from '../delete-document/delete-document.component';
import { ToastrService } from 'ngx-toastr';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { DomSanitizer } from '@angular/platform-browser';
import { ShowFileFromUrlComponent } from 'src/app/ChildControls/show-file-from-url/show-file-from-url.component';
import { ManageCatgoriesComponent } from 'src/app/AdminModule/AdminConfiguration/manage-catgories/manage-catgories.component';
import { configuration } from 'src/environments/environment';
import { patientobj, FluoroscopeImage } from '../../OR-Note/encounter-note/orfluoroscope-images/orfluoroscope-images.component';
import { FluoroscopeImageService } from 'src/app/Services/FluoroscopeImage/fluoroscope-image.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmltopdf from 'html-to-pdfmake'
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { IERxPDMPReportData } from 'src/app/models/IERxPDMPReportData';
import * as Enumerable from "linq-es2015";
import { NgxSpinnerService } from 'ngx-spinner';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { AuditLog } from 'src/app/models/iauditlog.model';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var $: any;
interface DBResultdata {
  _result: string,
  Permissions: string,
  DocumentPath: string
}

@Component({
  selector: 'app-view-document',
  templateUrl: './view-document.component.html',
  styleUrls: ['./view-document.component.css']
})
export class ViewDocumentComponent implements OnInit {
  i; list1;
  isImport = true;
  docmentInfo: IDocument;
  ViewDocForm: FormGroup;
  public docCatList: IDocument[] = [];
  public listProviders: IUserDetails[];
  public allDocList: IDocument_locname[] = [];
  public allDocTypesList: IDocument_locname[] = [];
  documenttab = 0;
  path: any = '';
  public faciliId: number;
  public docCatId: number = 0;
  public catName: string = '';
  public PatId: number;
  public filename: string;
  public myFiles: string[] = [];
  public result: any;
  public frmData: any;
  public fileExt: any;
  providerControl = new FormControl('', [Validators.required]);
  public dataSource: any;
  result1: string = '';
  facId: number = 0;
  disableTextbox = false;
  hideDocumentsHeader: boolean = true;
  displayedColumns: string[] = ['id', 'Documnet Name', 'DateOfService', 'Document Date', 'SubCategoryName', 'Location', 'Notes', 'Action'];//'Document Type',
  closeReport: boolean = true;
  //Dailog variable
  animal: string;
  name: string;
  allDocumentDetails: IDocument_locname[] = [];
  public getdocId: number = 0;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  oncategoryIndex: number = 0;
  public _SubCategoryDropDownList: IDocument_locname[] = [];
  public _SubCategoryAllList: IDocument_locname[] = [];
  eRxReportReviewedDatadates: IERxPDMPReportData;
  headerCloseIcon: boolean = false;
  isDelbtnDisabled: boolean = true;
  constructor(private fb: FormBuilder,
    private docService: DocumentService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private toastr: ToastrService, public sanitizer: DomSanitizer,
    private fluoroscopeService: FluoroscopeImageService,
    private rxservice: RxService,
    private sharedService: SharedService, private bannerService: PatientBannerService,
    private spinner: NgxSpinnerService//, private app: AppComponent
    , public dialogRef: MatDialogRef<ViewDocumentComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.hideDocumentsHeader = true;
    this.headerCloseIcon = false;
    if (sessionStorage.getItem("hideDocumentsHeader") != null && sessionStorage.getItem("hideDocumentsHeader") != undefined) {
      this.hideDocumentsHeader = false;
      this.headerCloseIcon = false;
    } else {
      this.hideDocumentsHeader = true;
      // this.headerCloseIcon = true;
    }
    this.getSystem();
    this.GetPatientChatDoc();
    this.getAllDocumentsTypes(CommonComponents.patientId);


    if (this.data != null) {
      this.isImport = this.data.isImport;
      if (this.isImport == false) {
        this.hideDocumentsHeader = false;
        this.headerCloseIcon = true;
      }
      else {
        // this.hideDocumentsHeader = true;
        // this.headerCloseIcon = true;
      }
    }
    else {
      this.isImport = true;
      this.hideDocumentsHeader = true;
      // this.headerCloseIcon = true;
    }

  }

  public show: boolean = false;
  getDocDestinationSubCategory(docCategoryId: number, CategoryName: String) {
    if (docCategoryId == 0)
      return "";
    if (this.DocDestinationSubCategory)
      if (CategoryName == 'FluoroImages' || CategoryName == 'FluoroReports')
        return this.DocDestinationSubCategory.filter(i => i.docCategoryId == docCategoryId && i.subCategoryName == CategoryName)
      else {
        let newsubcatlist: IDocument[] = []
        this.DocDestinationSubCategory.filter(i => i.docCategoryId == docCategoryId).forEach(x => {
          newsubcatlist.some(c => c.subCategoryName == x.subCategoryName) ? '' : newsubcatlist.push(x);
        });
        if (CategoryName == 'Patient') {
          if (!newsubcatlist.some(c => c.docCategoryId == docCategoryId && c.subCategoryName == 'Patient identifications')) {
            var object = new IDocument;

            object.docCategoryId = docCategoryId
            object.subCategoryName = 'Patient identifications'
            object.subCategoryId = -1
            object.documentCategory = CategoryName.toString();
            newsubcatlist.push(object);
          }
        }
        return newsubcatlist.sort((a, b) => a.subCategoryName.localeCompare(b.subCategoryName));
      }
    return "";
  }
  companies = [];
  pageNo: any = 1;
  pageNumber: boolean[] = [];
  searchValue: string = '';
  //Pagination Variables
  pageField = [];
  exactPageList: any;
  paginationData: number;
  companiesPerPage: any = 30;
  totalCompanies: any;
  totalCompaniesCount: any;
  disablePageCount: boolean = false;
  getCountAllDocumentsDetails(patientId, docCatId) {

    if (docCatId == 0) {
      docCatId = this.dropdownSelectValue;
    }
    this.docService.getCountDocuments(patientId, docCatId, this.ViewDocForm.value.searchTerm.toLowerCase().trim(), this.ViewDocForm.value.selectedcategory).subscribe(data => {
      this.totalCompaniesCount = data;
      if (this.totalCompaniesCount != 0) {
        if (this.totalCompaniesCount <= 20) {
          //this.disablePageCount = true;
        } else {
          this.disablePageCount = false;
        }
      }
      this.totalNoOfPages();
      $('#loaderRX').hide();
      $('#spdiv').hide();
    },
      error => {
        $('#loaderRX').hide();
        $('#spdiv').hide();
      });
  }
  totalNoOfPages() {
    this.pageField = [];
    this.paginationData = Number(this.totalCompaniesCount / Number(this.ViewDocForm.value.Pagecount));
    //let tempPageData = Number(this.paginationData.toFixed());
    //(tempPageData != this.paginationData) == true ? this.exactPageList = tempPageData + 1 : this.exactPageList = tempPageData;
    this.docService.exactPageList = this.round(this.paginationData.toString())
    this.docService.temppage = 0
    this.docService.pageOnLoad();
    this.pageField = this.docService.pageField;
    $('#loaderRX').hide();
    $('#spdiv').hide();
  }

  round(num) {
    let exactNum: number = 0;
    let splitNum = num.split(".");
    if (Number(splitNum[0]) == 0) {
      if (!num.includes(".")) {
        exactNum = num;
      }
      else
        exactNum = Number(splitNum[0]) + 1
    } else {
      if (!num.includes(".")) {
        exactNum = Number(num);
      } else {
        exactNum = Number(splitNum[0]) + 1
      }
    }
    return exactNum;
  }

  showCompaniesByPageNumber(page, i) {
    $('#loaderRX').show();
    $('#spdiv').show();
    this.companies = [];
    this.pageNumber = [];
    this.pageNumber[i] = true;
    this.pageNo = page;
    this.docService.temppage = 0;
    this.getAllDocumentsPagination(CommonComponents.patientId, Number(sessionStorage.getItem("FacilityId")), this.dropdownSelectValue, this.pageNo, this.ViewDocForm.value.Pagecount);
  }
  DocCheckDisabled: boolean = false;
  getAllDocumentsPagination(patientId: number, faciId: number, catId: number, pageNo: number, docperPage: number) {
    if (patientId != undefined) {
      this.docService.getallDocumentsDataPagination(patientId, faciId, catId, pageNo, docperPage, this.ViewDocForm.value.searchTerm.toLowerCase().trim(), this.ViewDocForm.value.selectedcategory).subscribe(data => {
        this.allDocList = data;
        this.mainincompletecheck = false;
        this.isDelbtnDisabled = true;
        this.selectedEncounters = [];
        this._SubCategoryAllList = this.allDocList;
        this._SubCategoryDropDownList = [];
        this.allDocList.forEach((element: IDocument_locname) => {
          element.DocNotes = element.DocNotes == null ? '' : element.DocNotes;
          if (this._SubCategoryDropDownList.filter(i => i.subCategoryName == element.subCategoryName).length == 0)
            this._SubCategoryDropDownList.push(element)
        });
        this.dataSource = new MatTableDataSource<IDocument_locname>(this.allDocList);
        this.originalArry = Object.assign([], this.allDocList);
        this.getAllDocCategoryList(this.isshowalldoc == true ? 1 : 0);
        this.gridFilter();
        this.getCountAllDocumentsDetails(this.ViewDocForm.value.patientId, this.docCatId);
        if (this.allDocList.filter(ele => (ele.CategoryPermissions == "" && ele.CategoryPermissions.split('~').includes('D') == false)).length == this.allDocList.length) {
          this.DocCheckDisabled = true; 
        } else {
          this.DocCheckDisabled = false;
        }
        this.AuditLogs("USP_EMR_GET_All_DOCUMENTS_PAGENATION", CommonComponents.patientId);
      },
        error => {
          $('#loaderRX').hide();
          $('#spdiv').hide();
        });
    }
    else {
      this.toastr.warning("Please select Patient Id");
      $('#loaderRX').hide();
      $('#spdiv').hide();
    }
  }

  getAllDocumentsTypes(patientId: number) {
    if (patientId != undefined) {
      this.docService.getallDocumentsTypes(patientId).subscribe(data => {
        this.allDocTypesList = data;
        this._SubCategoryDropDownList = [];
        this.allDocTypesList.forEach((element: IDocument_locname) => {
          element.DocNotes = element.DocNotes == null ? '' : element.DocNotes;
          if (this._SubCategoryDropDownList.filter(i => i.subCategoryName == element.subCategoryName).length == 0)
            this._SubCategoryDropDownList.push(element)
        })
        this.GetPatientDetails();
      },
        error => {
          $('#loaderRX').hide();
          $('#spdiv').hide();
        });
      //this.AuditLogs("USP_EMR_GET_All_DOCUMENTS", CommonComponents.patientId);
    }
    else {
      this.toastr.warning("Please select Patient Id");
    }
  }
  ShowHidePage: boolean = false;
  onSearchBtnClick() {
    if (this.ViewDocForm.value.searchTerm !== '' && this.ViewDocForm.value.searchTerm !== null && this.ViewDocForm.value.searchTerm !== undefined) {
      this.searchValue = this.ViewDocForm.value.searchTerm;
      this.pageNo = 1;
      this.pageNumber = [];
      this.pageNumber[0] = true;
      this.showCompaniesByPageNumber(1, 0);
      this.getCountAllDocumentsDetails(CommonComponents.patientId, this.docCatId)
    } else {
      this.toastr.warning("please enter search value");
    }
  }

  onClearBtnClick() {
    this.ViewDocForm.patchValue({
      searchTerm: '',
      selectedcategory: ''
    });
    this.dropdownSelectValue = 0;
    this.searchValue = '';
    this.pageNo = 1;
    this.pageNumber = [];
    this.pageNumber[0] = true;
    this.ShowHidePage = false;
    this.docService.temppage = 0;
    this.docCatId = 0;
    this.getAllDocumentsPagination(CommonComponents.patientId, Number(sessionStorage.getItem("FacilityId")), this.docCatId, this.pageNo, this.ViewDocForm.value.Pagecount);
  }

  IsDisableDoctype: boolean = false;
  createData() {
    this.frmData = new FormData();
    let docDate = this.datePipe.transform(this.ViewDocForm.controls['UDocDate'].value, "MM/dd/yyyy");
    this.frmData.append('DocumentID', this.CurrentElement.documentId);
    this.frmData.append('SrcDocPath', this.disableddoctype.includes(this.CurrentElement.DocumentType) ? null : this.CurrentElement.Docpath);
    this.frmData.append('DocName', this.ViewDocForm.controls['UDocname'].value);
    this.frmData.append('filename', this.CurrentElement.documentId + '.' + this.CurrentElement.extension)
    this.frmData.append('DocDate', docDate);
    this.frmData.append('Createdby', sessionStorage.getItem("userId").toString());
    this.frmData.append("SubCatID", this.disableddoctype.includes(this.CurrentElement.DocumentType) ? this.CurrentElement.subCategoryId : this.ViewDocForm.controls['UDocType'].value);
    this.frmData.append('FacilityId', Number(sessionStorage.getItem("FacilityId")));  // LocationId
    this.frmData.append('LocationId', this.disableddoctype.includes(this.CurrentElement.DocumentType) ? this.CurrentElement.locationId : this.ViewDocForm.controls['UDocLoc'].value);  // LocationId
    let catid = this.disableddoctype.includes(this.CurrentElement.DocumentType) ? this.CurrentElement.docCategoryId : this.DocDestinationSubCategory.filter(X => X.subCategoryId == this.ViewDocForm.controls['UDocType'].value).map(Y => Y.docCategoryId)[0]
    this.frmData.append("CatID", catid);
    this.frmData.append("DocNotes", this.ViewDocForm.controls['UDocNotes'].value);
    this.frmData.append("DocPath", this.CurrentElement.Docpath);
    this.frmData.append("PatientId", this.CurrentElement.patientId);
    return this.frmData;
  }

  DocDestinationSubCategory: IDocument[];
  async getAllSubCategoryList() {
    this.docService.getAllSubCategory().subscribe(data => {
      data = data.filter(i => i.subCategoryName != 'Patient identifications license');
      this.DocDestinationSubCategory = data;
      //this.AuditLogs("USP_GET_DOCUMENT_SUBCATEGORIES", CommonComponents.patientId);
    });
  }

  showInfo(event, element) {
    this.spinner.show();
    this.CurrentElement = element;
    this.show = !this.show;
    this.IsDisableDoctype = this.disableddoctype.includes(element.DocumentType)
    this.ViewDocForm.controls['UDocname'].setValue(element.documentName);
    if (element.documentCategory == "FluoroImages" || element.documentCategory == "FluoroReports") {
      var filterlist = this.DocDestinationSubCategory.filter(x => x.docCategoryId == element.docCategoryId && x.subCategoryName == element.documentCategory);
      if (filterlist.length > 0) {
        this.ViewDocForm.controls['UDocType'].setValue(filterlist[0].subCategoryId);
      }
      else {
        this.ViewDocForm.controls['UDocType'].setValue(element.subCategoryId);
      }
    }
    else if (element.DocumentType == "Insurance Card" || element.DocumentType == "License Card") {
      var filterlist = this.DocDestinationSubCategory.filter(x => x.docCategoryId == element.docCategoryId && x.subCategoryName == 'Patient identifications');
      if (filterlist.length > 0) {
        this.ViewDocForm.controls['UDocType'].setValue(filterlist[0].subCategoryId);
      }
    }
    else {
      if (element.subCategoryName == "FluoroReports") {
        let newsubcatlist: IDocument[] = []
        this.DocDestinationSubCategory.filter(i => i.docCategoryId == element.docCategoryId).forEach(x => {
          newsubcatlist.some(c => c.subCategoryName == x.subCategoryName) ? '' : newsubcatlist.push(x);
        });
        if (newsubcatlist.length > 0) {
          var newobj = newsubcatlist.filter(x => x.subCategoryName == element.subCategoryName);
          this.ViewDocForm.controls['UDocType'].setValue(newobj[0].subCategoryId);
        }
      } else {
        this.ViewDocForm.controls['UDocType'].setValue(element.subCategoryId);
      }
    }

    this.disableddoctype.includes(element.DocumentType) ? this.ViewDocForm.controls['UDocType'].disable() : this.ViewDocForm.controls['UDocType'].enable();
    this.ViewDocForm.controls['UDocLoc'].setValue(element.locationId);
    this.disableddoctype.includes(element.DocumentType) ? this.ViewDocForm.controls['UDocLoc'].disable() : this.ViewDocForm.controls['UDocLoc'].enable();
    this.ViewDocForm.controls['UDocDate'].setValue(new Date(element.documentdate));
    this.ViewDocForm.controls['UDocNotes'].setValue(''); //element.DocNotes

    this.docService.GetDocNotesLog(element.documentId).subscribe(result => {
      this.DocNotes = result
      this.spinner.hide();
    },
      error => {
        this.spinner.hide();
      });
    this.CurrentElement = element;
  }

  DocNotes: IDocument_locname[] = [];
  CurrentElement: IDocument_locname
  closeIcon() {
    this.show = false;
  }

  today = new Date();
  UpdateDocData() {
    try {
      if (this.IsvalidData()) {
        this.spinner.show();
        this.docService.UpdateDocumentNotes(this.createData()).subscribe(results => {
          if (results.includes('successfully')) {
            this.toastr.success("Document updated successfully")
            this.closeIcon();
            var _subcatID = this.disableddoctype.includes(this.CurrentElement.DocumentType) ? this.CurrentElement.subCategoryId : this.ViewDocForm.controls['UDocType'].value;
            var _subcatname = this.disableddoctype.includes(this.CurrentElement.DocumentType) ? this.CurrentElement.subCategoryName : this.DocDestinationSubCategory.filter(X => X.subCategoryId == _subcatID).map(Y => Y.subCategoryName)[0];
            var _catID = this.disableddoctype.includes(this.CurrentElement.DocumentType) ? this.CurrentElement.docCategoryId : this.DocDestinationSubCategory.filter(X => X.subCategoryId == _subcatID).map(Y => Y.docCategoryId)[0]
            var _catName = this.DocDestinationSubCategory.filter(X => X.subCategoryId == _subcatID).map(Y => Y.documentCategory)[0];
            var _locId = this.disableddoctype.includes(this.CurrentElement.DocumentType) ? this.CurrentElement.locationId : this.ViewDocForm.controls['UDocLoc'].value
            var _locName = this.lstLocations.filter(x => x.locationId == _locId).map(z => z.locationName)[0]
            var _docnotes = this.ViewDocForm.controls['UDocNotes'].value
            let jsonObj: any = JSON.parse(results); // string to generic object first
            let dbResultdata: DBResultdata = <DBResultdata>jsonObj;
            this._SubCategoryAllList.filter(x => x.documentId == this.CurrentElement.documentId).map(z => {
              z.documentName = this.ViewDocForm.controls['UDocname'].value,
                z.documentdate = this.datePipe.transform(this.ViewDocForm.controls['UDocDate'].value, "MMM dd, yyyy"),
                z.locationId = _locId,
                z.LocationName = _locName,
                (z.docCategoryId != _catID ? this.getAllDocCategoryList(this.isshowalldoc == true ? 1 : 0) : ''),
                z.docCategoryId = _catID,
                z.documentCategory = _catName,
                z.subCategoryId = _subcatID,
                z.subCategoryName = _subcatname,
                z.DocNotes = (_docnotes.trim() == '' ? z.DocNotes : _docnotes),
                z.CategoryPermissions = dbResultdata.Permissions;
              z.Docpath = dbResultdata.DocumentPath;
            });

            this.allDocList = this._SubCategoryAllList;
            this.gridFilter();
            this.getAllDocumentsTypes(CommonComponents.patientId);
          }
          this.spinner.hide();
        },
          error => {
            this.toastr.error("Unable to update the document, please try again");
            this.spinner.hide();
          });
      }
    }
    catch (ex) {
      this.spinner.hide();
    }
    finally {
      this.spinner.hide();
    }
  }

  IsvalidData() {
    var obj = this.ViewDocForm.controls['UDocname'].value;
    if (obj.trim() == '') {
      this.toastr.warning('Please Enter Valid Document Name');
      return false;
    }
    else if (obj.length > 200) {
      this.toastr.warning('Document Name Max Length upto 200 only');
      return false;
    }
    else if (this._SubCategoryAllList.some(x => x.documentName.trim() == obj.trim() && x.documentId != this.CurrentElement.documentId)) {
      this.toastr.warning('Document Name already exists,Please Use anothername');

      return false;
    }
    obj = this.ViewDocForm.controls['UDocDate'].value;
    if (!(obj || obj != '')) {
      this.toastr.warning('Please Enter Valid Document Date');
      return false;
    }
    obj = this.ViewDocForm.controls['UDocType'].value;
    if (!(obj || obj == typeof (Number))) {
      this.toastr.warning('Please select Valid Document Type');
      return false;
    }
    obj = this.ViewDocForm.controls['UDocLoc'].value;
    if (!(obj || obj == typeof (Number))) {
      this.toastr.warning('Please select Valid Document Location');
      return false;
    }
    return true
  }
  getSystem() {
    if (sessionStorage.getItem("patientName") != null || sessionStorage.getItem("patientName") != undefined) {
      CommonComponents.patientName = sessionStorage.getItem("patientName");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    if (sessionStorage.getItem("FacilityId") != null || sessionStorage.getItem("FacilityId") != undefined) {
      this.facId = Number(sessionStorage.getItem("FacilityId"));
    }
  }

  isshowalldoc: Boolean = false
  showOptions(ischecked: boolean) {

    this.isshowalldoc = ischecked ? ischecked : false;
    this.getAllDocCategoryList(this.isshowalldoc == true ? 1 : 0);
  }

  formErrors = {
    'documentCategory': '',
    'docDescription': '',
    'documentName': '',
    'documentdate': '',
  };

  validationMessages = {
    'documentCategory': {
      'required': 'Please Select the Document Category',
    },
    'docDescription': {
      'required': 'Please Enter Document Description'
    },
    'documentName': {
      'required': 'Please Upload the Document'
    },
    'documentdate': {
      'required': 'Please Select the Current Date'
    },
  };

  isroleForEDIT: boolean = false;
  ngOnInit() {
    this.isroleForEDIT = sessionStorage.getItem('role') == 'Admin'
    this.getUserLocations();
    this.ViewDocForm = this.fb.group({
      documentId: [''],
      documentName: ['', Validators.required],
      documentdate: ['', Validators.required],
      subCategoryId: [''],
      patientId: [''],
      patientName: [''],
      selectedcategory: [''],
      filteredFileName: [''],
      filteredDate: [''],
      filteredDocType: [''],
      filteredLocation: [''],
      filteredNotes: [''],
      filteredSubcat: [''],
      UDocNotes: [''],
      UDocType: [''],
      UDocLoc: [''],
      UDocDate: [''],
      UDocname: [''],
      searchTerm: ['',],
      Pagecount: [''],
      filteredDOS: ['']
    });

    this.ViewDocForm.controls["Pagecount"].setValue(100);
    this.GetOnlyALLDOCCATEGORIES();
    setTimeout(() => {
      if (sessionStorage.getItem("fromscreen") != null || sessionStorage.getItem("fromscreen") != undefined) {
      } else {
        CommonComponents.demoheaderVisibility = true;
        sessionStorage.setItem("displayappDate", null);
        sessionStorage.setItem("displayappDate1", null);
        this.bannerService.toggle(CommonComponents.patientId);
      }
    }, 700)
    this.isshowalldoc = false;
  }
  gridFilter() {
    this.allDocList = this._SubCategoryAllList;
    var Selcategory = this.ViewDocForm.controls["selectedcategory"].value;
    if (Selcategory != "")
      this.allDocList = this.allDocList.filter(i => i.subCategoryName == Selcategory);

    if (this.ViewDocForm.controls["filteredFileName"].value !== '') {
      this.allDocList = this.allDocList.filter(i => i.documentName != null && i.documentName.toLowerCase().indexOf(this.ViewDocForm.controls["filteredFileName"].value.toLowerCase()) > -1)
    }
    if (this.ViewDocForm.controls["filteredDate"].value !== "") {
      this.allDocList = this.allDocList.filter(i => i.documentdate != null && i.documentdate.toLowerCase().indexOf(this.ViewDocForm.controls["filteredDate"].value.toLowerCase()) > -1)
    }
    if (this.ViewDocForm.controls["filteredDocType"].value !== "") {
      this.allDocList = this.allDocList.filter(i => i.DocumentType != null && i.DocumentType.toLowerCase().indexOf(this.ViewDocForm.controls["filteredDocType"].value.toLowerCase()) > -1)
    }
    if (this.ViewDocForm.controls["filteredSubcat"].value !== "") {
      this.allDocList = this.allDocList.filter(i => i.subCategoryName != null && i.subCategoryName.toLowerCase().indexOf(this.ViewDocForm.controls["filteredSubcat"].value.toLowerCase()) > -1)
    }

    if (this.ViewDocForm.controls["filteredLocation"].value !== "") {
      this.allDocList = this.allDocList.filter(i => i.LocationName != null && i.LocationName.toLowerCase().indexOf(this.ViewDocForm.controls["filteredLocation"].value.toLowerCase()) > -1)
    }

    if (this.ViewDocForm.controls["filteredNotes"].value !== "") {
      this.allDocList = this.allDocList.filter(i => i.DocNotes != null && i.DocNotes.toLowerCase().indexOf(this.ViewDocForm.controls["filteredNotes"].value.toLowerCase()) > -1)
    }
    if (this.ViewDocForm.controls["filteredDOS"].value !== "") {
      this.allDocList = this.allDocList.filter(i => i.visitDate != null && i.visitDate.toLowerCase().indexOf(this.ViewDocForm.controls["filteredDOS"].value.toLowerCase()) > -1)
    }

    this.dataSource = new MatTableDataSource<IDocument_locname>(this.allDocList);
    this.originalArry = Object.assign([], this.allDocList);
    this.dataSource.paginator = this.paginator;


    this.allDocList.forEach((element: IDocument_locname) => {
      element.DocNotes = element.DocNotes == null ? '' : element.DocNotes;
      if (this._SubCategoryDropDownList.filter(i => i.subCategoryName == element.subCategoryName).length == 0)
        this._SubCategoryDropDownList.push(element)
    });

    if (this.allDocList.filter(ele => (ele.CategoryPermissions == "" && ele.CategoryPermissions.split('~').includes('D') == false)).length == this.allDocList.length) {
      this.DocCheckDisabled = true;
    } else {
      this.DocCheckDisabled = false;
    }
    var seletlist = this.dataSource.data.filter(x => x.isSelected == true && (x.CategoryPermissions && x.CategoryPermissions.split('~').includes('D')) != false);
    this.isDelbtnDisabled = seletlist.length > 0 ? false : true;
    this.selectedEncounters = seletlist;
  }


  GetPatientDetails() {
    $('#loaderRX').show();
    $('#spdiv').show();
    this.ViewDocForm.patchValue({
      patientId: CommonComponents.patientId,
      patientName: CommonComponents.patientName,
      documentCategory: this.catName,
      documentdate: new Date(),
    });
    let clientId = 0;
    this.showCompaniesByPageNumber(1, 0)
  }


  onCategoryClicked(index: number, item: any, doccatid: number) {
    this.getdocId = doccatid;
    this.docCatId = doccatid;
    this.oncategoryIndex = doccatid;
    this.pageNo = 1;
    this.companiesPerPage = 30;
    this.catName = '';
    this.docService.temppage = 0;
    this.ViewDocForm.patchValue({ searchTerm: '' })
    this.faciliId = Number(sessionStorage.getItem("FacilityId"));
    if (item != null && item != undefined) {
      this.faciliId = item.facilityId;
      this.catName = item.documentCategory;
      this.docCatId = item.docCategoryId;
      this.oncategoryIndex = item.docCategoryId;
      this.dropdownSelectValue = item.docCategoryId;
    } else {
      this.dropdownSelectValue = doccatid;
    }

    if (this.isshowalldoc == true && doccatid == 0) {
      this.getAllDocCategoryList(this.isshowalldoc == true ? 1 : 0);
    }
    this.ViewDocForm.controls["selectedcategory"].setValue("");
    this.GetPatientDetails();
  }

  ShowAllLocations(event) {
    if (event.checked) {
      let doccatId = 0;
      this.getAllDoc(this.ViewDocForm.value.patientId, Number(sessionStorage.getItem("FacilityId")), doccatId, Number(sessionStorage.getItem("FacilityId")));
    } else {
      let doccatId = 0;
      let clientId = 0;
      this.getAllDoc(this.ViewDocForm.value.patientId, Number(sessionStorage.getItem("FacilityId")), doccatId, clientId);
    }
  }

  AlldocCatList: IDocument[];
  public lstLocations: ILocationDetails[] = [];
  async getUserLocations() {
    await this.sharedService.getLocationsByUser().subscribe(data => {
      this.lstLocations = data;
    });
  }

  ALLDocCatgories_only: any
  GetOnlyALLDOCCATEGORIES() {
    this.docService.getAllDocCategory(0, Number(sessionStorage.getItem("FacilityId")), 0).subscribe(data => {
      this.ALLDocCatgories_only = data
      //this.AuditLogs("USP_EMR_GET_ALLDOCCATEGORIES", CommonComponents.patientId);
    });

  }

  getAllDocCategoryList(isalldoccatlist: number) {
    if (sessionStorage.getItem('patientId') != null && sessionStorage.getItem('patientId') !== undefined) {
      this.docService.getAllDocCategory(Number(sessionStorage.getItem('patientId')), Number(sessionStorage.getItem("FacilityId")), isalldoccatlist).subscribe(data => {
        this.getAllSubCategoryList();
        this.AlldocCatList = data;
        if (isalldoccatlist) {
          this.docCatList = this.AlldocCatList;
        }
        else {
          this.docCatList = this.AlldocCatList.filter(item => item.count > 0);
        }
        //this.AuditLogs("USP_EMR_GET_ALLDOCCATEGORIES", CommonComponents.patientId);
      }, error => {
        $('#loaderRX').hide();
        $('#spdiv').hide();
      });
    }
    else {
      $('#loaderRX').hide();
      $('#spdiv').hide();
      this.toastr.warning("Please select Patient Id");
    }
  }

  public _auditLog: AuditLog;
  AuditLogs(sp: any, input: any) {
    this._auditLog = new AuditLog();
    this._auditLog.InputParameters = input;
    this._auditLog.SPName = sp;
    this.sharedService.selectCopyPrintAuditLog(this._auditLog).subscribe(async result => {
      await result;
    });
  }

  dropdownSelectValue: number = 0;
  selectedCategoryName: string = '';
  onSubCatSelectChange(evantvalue, pageNum, pagesize) {
    this.selectedCategoryName = evantvalue;
    this.pageNumber = [];
    this.pageNumber[0] = true;
    this.pageNo = 1;
    this.docService.temppage = 0;
    if (evantvalue != "") {
      $('#loaderRX').show();
      $('#spdiv').show();
      this.docService.getallDocumentsDataPagination(CommonComponents.patientId, Number(sessionStorage.getItem("FacilityId")), 0, 1, 100, this.ViewDocForm.value.searchTerm.toLowerCase().trim(), this.ViewDocForm.value.selectedcategory).subscribe(data => {
        this.mainincompletecheck = false;
        this.isDelbtnDisabled = true;
        this.selectedEncounters = [];
        this.allDocList = data;
        this._SubCategoryAllList = this.allDocList;
        if (this._SubCategoryAllList.length != 0) {
          var t = this._SubCategoryAllList.filter(x => x.subCategoryName == evantvalue);
          this.dropdownSelectValue = t[0].docCategoryId;
        } else {
          this.dropdownSelectValue = 0;
        }
        this.allDocList.forEach((element: IDocument_locname) => {
          element.DocNotes = element.DocNotes == null ? '' : element.DocNotes;
          if (this._SubCategoryDropDownList.filter(i => i.subCategoryName == element.subCategoryName).length == 0)
            this._SubCategoryDropDownList.push(element)
        });
        this.dataSource = new MatTableDataSource<IDocument_locname>(this.allDocList);
        this.originalArry = Object.assign([], this.allDocList);
        this.getAllDocCategoryList(this.isshowalldoc == true ? 1 : 0);
        this.gridFilter();
        this.getCountAllDocumentsDetails(this.ViewDocForm.value.patientId, this.docCatId);
        if (this.allDocList.filter(ele => (ele.CategoryPermissions == "" && ele.CategoryPermissions.split('~').includes('D') == false)).length == this.allDocList.length) {
          this.DocCheckDisabled = true;
        } else {
          this.DocCheckDisabled = false;
        }
      },
        error => {
          $('#loaderRX').hide();
          $('#spdiv').hide();
        });
    } else {
      this.dropdownSelectValue = 0;
      this.allDocList = this._SubCategoryAllList;
      this.dataSource = new MatTableDataSource<IDocument_locname>(this.allDocList);
      this.originalArry = Object.assign([], this.allDocList);
      this.dataSource.paginator = this.paginator;
      this.gridFilter();
      this.GetPatientDetails();
    }
  }

  onPagenationSelectChange() {
    this.GetPatientDetails()
  }
  disableddoctype = ["Insurance Card", "License Card", "PDMP Report", "TELEMEDECINE"]
  getAllDoc(patientId: number, faciId: number, catId: number, clientId: number) {
    if (patientId != undefined) {
      $('#loaderRX').show();
      this.docService.getAllDocumentslocName(patientId, faciId, catId, clientId).subscribe(data => {
        this._SubCategoryDropDownList = [];
        this.allDocList.forEach((element: IDocument_locname) => {
          element.DocNotes = element.DocNotes == null ? '' : element.DocNotes;
          if (this._SubCategoryDropDownList.filter(i => i.subCategoryName == element.subCategoryName).length == 0)
            this._SubCategoryDropDownList.push(element)
        })
        this._SubCategoryAllList = this.allDocList;
        this.dataSource = new MatTableDataSource<IDocument_locname>(this.allDocList);

        this.dataSource.paginator = this.paginator;

        this.docCatList.filter(x => x.docCategoryId == catId).map(y => y.count = this.allDocList.length);
        this.gridFilter();
      }, error => {
        $('#loaderRX').hide();
        $('#spdiv').hide();
      });
      //this.AuditLogs("USP_EMR_GET_All_DOCUMENTS", CommonComponents.patientId);
    }
    else {
      this.toastr.warning("Please select Patient Id");
    }
  }

  alllocation: number = 0;
  manageCategorypop(): any {
    const dialogRef = this.dialog.open(ManageCatgoriesComponent, {
      width: '500px',
      height: '260px',
      data: this.ViewDocForm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.docmentInfo = result;
        if (this.docmentInfo.extension !== '') {
          this.alllocation = this.facId;
        } else {
          this.alllocation = 0;
        }
        if (this.docmentInfo.subCategoryName === "") {
          this.SaveCategory(this.docmentInfo)
        } else {
          this.SaveSubCategory(this.docmentInfo);
        }
      }

    });
  }

  SaveCategory(docmentInfo): void {
    this.docService.SaveDocCategory(docmentInfo, this.alllocation).subscribe((results: any) => {
      this.result = results;
      this.toastr.success('Document Category Saved Successfully');
      this.getAllDocCategoryList(this.isshowalldoc == true ? 1 : 0);
    });
  }

  SaveSubCategory(docmentInfo): void {
    this.docService.SaveSubCategory(docmentInfo).subscribe((results: any) => {
      this.result = results;
      this.toastr.success('Document Type Saved Successfully');
    });
  }

  confirmDialog(element, type: string): void {

    const message = (type == "DelOne") ? "Upon Clicking on ‘Yes’, the selected line-item document gets deleted.<br/><br/>Click ‘No’ to close this confirmation pop-up with no other action performed." : (type == "DelAll") ? "Upon Clicking on ‘Yes’, the selected document(s) get deleted.<br/><br/>Click ‘No’ to close this confirmation pop-up with no other action performed." : "";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '470px',
      height: '150px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result1 = dialogResult;
      if (this.result1) {

        if (type == "DelOne") {
          this.selectedEncounters = [];
          this.selectedEncounters.push(element);
        }
        this.DeleteDoc(this.selectedEncounters, type);
      } else {
        this.result1 = dialogResult;
      }

      dialogRef.close(true);
    });
  }

  DeleteDoc(docobj: IDocument[], type: string) {
    $('#loaderRX').show();
    $('#spdiv').show();
    this.docService.deleteDocument(docobj).subscribe((results: any) => {

      this.result = results;
      if (this.selectedEncounters.length == this.originalArry.length) {
        this.pageNo = 1;
        this.pageNumber = [];
        this.pageNumber[0] = true;
        this.docService.temppage = 0;
      }
      if (this.getdocId === 0) {
        this.getAllDocumentsPagination(CommonComponents.patientId, Number(sessionStorage.getItem("FacilityId")), this.getdocId, this.pageNo, this.ViewDocForm.value.Pagecount);
      } else {
        this.getAllDocumentsPagination(CommonComponents.patientId, Number(sessionStorage.getItem("FacilityId")), this.getdocId, this.pageNo, this.ViewDocForm.value.Pagecount);
      }
      if (type == "DelOne") {
        this.toastr.success('Document Deleted Successfully');
      } else if (type == "DelAll") {
        this.toastr.success('Selected Document(s) Deleted Successfully');
      }
    },
      error => {
        $('#loaderRX').hide();
        $('#spdiv').hide();
      });
  }

  toggleDisable() {
    this.disableTextbox = !this.disableTextbox;
  }
  fluoroPreviewList: FluoroscopeImage[] = [];
  lblpdmprepHtml: any;
  isimagecheck: boolean = false;
  val: number = 0;
  reporturl;
  PreviewFile(event: Event, element: IDocument_locname) {
    this.closeReport = true;
    if (element.DocumentType == "PDMP Report") {
      this.spinner.show();
      this.val = parseInt($("#hideTxtBox").val());
      $("#hideTxtBox").val(this.val++);
      this.rxservice.getRxReportReviewedDetailsbyEncounterId(element.encounterId).subscribe(
        data => {
          this.closeReport = true;
          if (data !== null && data !== undefined) {
            try {
              this.eRxReportReviewedDatadates = data
              this.pdmprepHTMLcontent = this.eRxReportReviewedDatadates.reportHtmlData;
              try {
                this.reporturl = this.sanitizer.bypassSecurityTrustResourceUrl(this.eRxReportReviewedDatadates.reportHtmlData);
                if (this.val == 1) {
                  this.PreviewFile(null, element);
                } else {
                  $("#pdmprep").show('slide', { direction: 'right' }, 1000);
                  this.spinner.hide();
                }
              } catch (e) {
                this.spinner.hide();
                if (this.val <= 3) {
                  this.PreviewFile(null, element);
                }
              }
            } catch (e) {
              this.spinner.hide();
              if (this.val <= 3) {
                this.PreviewFile(null, element);
              }
            }
          } else {
            this.toastr.warning("unable to pull report");
            this.spinner.hide();
          }
        });
    // } else if (element.DocumentType == "TELEMEDECINE") {
    //   let patchatDocObj = this.patTeleDocsList.filter(x => x.documentId == Number(element.documentId));
    //   let docObj = this.sanitizer.bypassSecurityTrustResourceUrl(patchatDocObj[0].documentText);
    //   this.openDialog(docObj)
    }
    else {
      this.docService.viewDocument(element.documentName, element.Docpath).subscribe(path => {
        if (path != "" && path.length > 0) {
          var filepath = this.sanitizer.bypassSecurityTrustResourceUrl(path);
          this.openDialog(filepath);
        }
        else {
          this.toastr.error("File not found");
        }
      })
      // let ele = element.Docpath.split('\\');
      // ele.shift()
      // ele.push(element.documentId + "." + element.extension)
      // const filepath0 = ele.join("/");
      // const filePath1 = element.facilityId + "/" + element.patientId + "/" + element.docCategoryId + "/" + element.subCategoryId + "/" + element.documentId + "." + element.extension;
      // const filePath2 = element.locationId + "/" + element.patientId + "/" + element.docCategoryId + "/" + element.subCategoryId + "/" + element.documentId + "." + element.extension;
      // const urlArray: string[] = [];
      // urlArray.push(filepath0);
      // urlArray.push(filePath1);
      // urlArray.push(filePath2);
      // this.isUrlFound(urlArray, element.documentName);
    }
    this.AuditLogs("USP_EMR_GET_All_DOCUMENTS_PAGENATION", CommonComponents.patientId);
  }

  callprintDiv() {


    let frame
    let frameBody

    frame = document.getElementById('ifrmpdmp')

    frameBody = document.getElementById('ifrmpdmp').outerHTML; //will get all html within the iframe


    let printContents, popupWin;

    // let printHeader = document.getElementById('.vs-main').innerHTML; //will get html of the div by id

    popupWin = window.open('', '_blank', 'top=0,left=0, width=1400,height=1400');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
        <title>Print Preview</title>

        <style>

        @media print {
          md-content {
            overflow: visible !important;
          }
          * { overflow: visible !important; }
          body, html, .vs-main {
              height: 100% !important;
              width: 100% !important;
          }

         </style>
        </head>
     <body >


      ${frameBody}
       </body>
       </html>`
    );
    popupWin.print();
    //popupWin.document.close();
    // ${printHeader}
    // ${frameBody}
    //     var loadfun = ' 'onload="window.print();window.close()"
    //     var printContents = this.pdmprepHTMLcontent.replace('<head>', '<head> <style type="text/css" media="print">@page { size: landscape;  }:host ::ng-deep .vs-main .vs-heading {    position: absolute;    top: 0;    width: 100%;    background-color: #fff;    border-bottom: 1px solid #f2f2f2;    z-index: 100;}</style>');
    //     printContents = printContents.replace('class="vs-heading"', 'class="vs-heading" style="display:none;')
    //     printContents = printContents.replace('</head>', '<script src="https://code.jquery.com/jquery-1.9.1.min.js"></script>' +
    //       '<script>$( document ).ready(function() {    console.log( "document loaded" ); $(".vs-heading").addClass("vs-headingnoscroll").removeClass("vs-heading");' +
    //       'if ($(".uk-accordion-title")[0] !== null && $(".uk-accordion-title")[0] !== undefined) {' +
    //       '$(".uk-accordion-title")[0].click();      }  });' +
    //       '$( window ).on( "load", function() {    console.log( "window loaded" );}); </script></head>')

    //     printContents = printContents.replace('<body>', '<body onBlur=“window.focus()”>')
    //     const winUrl = URL.createObjectURL(
    //       new Blob([printContents], { type: "text/html" })
    //     );
    //     printContents = printContents.replace('<title>', '<title>PDMP REPORT')
    //     let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    // width=`+ screen.availWidth + `,height=` + screen.availHeight + `,screenX=10,screenY=10`;
    //     const win = window.open(
    //       winUrl,
    //       "win",
    //       params
    //     );
    //     setTimeout(() => {
    //       win.print();
    //     }, 1500);
    //     return;
    // var printContents = this.pdmprepHTMLcontent;
    // printContents.replace('<head>', '<head><style type="text/css" media="print">@page { size: landscape; }</style>')
    // var popupWin = window.open('', '_blank', 'width=800,height=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
    // popupWin.window.focus();
    // popupWin.document.open();
    // popupWin.document.write(printContents);
    // popupWin.print();
  }
  pdmprepHTMLcontent: any;

  isUrlFound(urlArray: string[], DocumentName: string) {
    this.docService.getValidFilePath(urlArray, DocumentName).subscribe(path => {
      if (path != "" && path.length > 0) {
        var filepath = this.sanitizer.bypassSecurityTrustResourceUrl(configuration.documentUrl + path);
        this.openDialog(filepath);
      }
      else {
        this.toastr.error("File not found");
      }
    })
  }
  GetReportReviewedDates() {
    this.rxservice.getRxReportReviewedDetailsbyEncounterId(CommonComponents.encounterId).subscribe(
      data => {
        this.eRxReportReviewedDatadates = data
      });
  }

  openDialog(path: any): void {
    const dialogRef = this.dialog.open(ShowFileFromUrlComponent, {
      width: '810px', height: '100%', data: { url: path }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined)
        { }
    });
  }

  uploadimgList: FluoroscopeImage[] = [];
  GetFluoroscopeImages() {
    this.fluoroscopeService.GetDocumentFluoreScopeImages().subscribe(
      data => {
        this.uploadimgList = [];
        this.uploadimgList = data;
      }, (err: any) => console.log(err));
  }

  patTeleDocsList: PatientTeleDoc[] = [];
  GetPatientChatDoc() {
    this.docService.GetPatientChatDoc().subscribe(data => {
      this.patTeleDocsList = data;
    });
  }

  downloadPDF() {
    if (this.fluoroPreviewList.length > 0) {
      var headerContent = '<table width="650" style="margin-left: 60px;"><thead><th>PATIENT NAME</th><th>PATIENT ID</th><th>DOB</th><th>AGE</th><th>SEX</th><th>DOS</th><th>PHYSICIAN</th></thead>';
      headerContent += '<tbody><tr><td>' + this.patData.fullName + '</td><td>' + this.patData.patientId + '</td><td>' + this.patDOB + '</td><td>' + this.patAge + '</td><td>' + this.patData.gender + '</td><td>' + this.visitDate + '</td><td>' + this.patData.practiceProvider + '</td></tr></tbody></table>';
      var headerHTML = htmltopdf(headerContent)
      var html = htmltopdf(this.getneratePDF());//$("#content").html());
      let docDefinition = {
        pageSize: 'LETTER',
        footer: function (currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },
        header: headerHTML,
        content: html,
        pageMargins: [40, 60, 40, 60]
      };
      pdfMake.createPdf(docDefinition).open();
      this.isimagecheck = false;

    } else {
      //this.toastr.warning("No one select Images");
    }
  }


  getneratePDF(): string {
    var html = '<html><head><style></style></head><body><table width="630"><tbody>';
    var ht = '';
    var skipCount = 0;
    var rowsItrations = 0;
    if (this.fluoroPreviewList.length > 0) {
      rowsItrations = Math.ceil(this.fluoroPreviewList.length / 2);
      for (var i = 0; i < rowsItrations; i++) {
        var selectedImages = Enumerable.AsEnumerable(this.fluoroPreviewList).Skip(skipCount).Take(2).ToArray();
        ht += '<tr>';
        var htmlcontentForImages = selectedImages.map(function (item) {
          if (selectedImages.length == 2) {
            return '<td><img width="315" height="315" src="' + item.imageData + '" /></td>';
          } else {
            return '<td colspan="2"><img width="315" height="315" src="' + item.imageData + '" /></td>';
          }
        });
        ht += htmlcontentForImages.join("") + '</tr>';
        ht += '<tr>';
        var htmlcontentForTitles = selectedImages.map(function (item) {
          if (selectedImages.length == 2) {
            return '<td>' + item.imageDate + '</td>';
          } else {
            return '<td colspan="2">' + item.imageDate + '</td>';
          }
        });
        ht += htmlcontentForTitles.join("") + '</tr>';
        skipCount = skipCount + selectedImages.length;
      }
    }
    return html + ht + '</tbody></table></body></html>';
  }

  patData: patientobj;
  patAge: any;
  patDOB: string;
  visitDate: string;
  async GetpatientData(encId: string) {
    this.fluoroscopeService.GetPatDetailsByEncId(encId).subscribe(
      data => {
        this.patData = data;
        this.patDOB = formatDate(this.patData.dob, 'MM-dd-yyyy', 'en-US');
        this.visitDate = formatDate(this.patData.visitDate, 'MM-dd-yyyy', 'en-US');
        var visitDate1 = formatDate(this.patData.visitDate, 'MM-dd-yyyy hhmm', 'en-US');
        var dob = this.datePipe.transform(this.patData.dob, "MM/dd/yyyy");
        var _age = "0";
        if (dob != '') {
          var birthdate = new Date(dob);
          var todayDate = new Date();
          var ageyear = todayDate.getFullYear() - birthdate.getFullYear();
          var agemonth = todayDate.getMonth() - birthdate.getMonth();
          var ageday = todayDate.getDate() - birthdate.getDate();

          var nowDay = todayDate.getDate();
          var dobDay = birthdate.getDate();

          if (agemonth <= 0) {
            ageyear--;
            agemonth = (12 + agemonth);
          }
          if (nowDay < dobDay) {
            agemonth--;
            ageday = 30 + ageday;
          } if (agemonth == 12) {
            ageyear = ageyear + 1;
            agemonth = 0;
          }

          if (ageyear != 0) {
            _age = ageyear + ' Y';
          } else if (agemonth <= 11 && agemonth > 0) {
            _age = agemonth + ' M';
          } else {
            _age = ageday + ' D';
          }
          CommonComponents.patientAge = _age.toString();
          this.patAge = _age;
        } else {
          this.patAge = _age + ' D';
        }
        this.downloadPDF();
      });
  }
  onclearPrintReport() {
    $("#pdmprep").hide('slide', { direction: 'right' }, 1000);
  }

  oncellclick(element) {
    // if (this.isImport == true)
    this.dialogRef.close(element);
  }
  ColseAlert() {
    sessionStorage.removeItem("hideDocumentsHeader");
  }

  selectedEncounters: IDocument_locname[] = [];
  mainincompletecheck: boolean = false;
  checkAndUncheck(event) {

    this.selectedEncounters = [];
    if (event.checked) {
      this.mainincompletecheck = true;
      this.dataSource.data.forEach(element => {
        if ((element.CategoryPermissions && element.CategoryPermissions.split('~').includes('D')) == false)
          element.isSelected = false;
        else
          element.isSelected = true;
      });
    } else {
      this.dataSource.data.forEach(element => {
        element.isSelected = false;
      });
    }
    var seletlist = this.dataSource.data.filter(x => x.isSelected == true);
    this.isDelbtnDisabled = seletlist.length > 0 ? false : true;
    this.selectedEncounters = seletlist;
  }
  originalArry: IDocument_locname[] = [];
  singleCheck(element: IDocument_locname, event) {

    if (event.checked) {
      var existlist = this.dataSource.data.filter(x => x.documentId == element.documentId);
      if (existlist.length > 0) {
        var index1 = this.dataSource.data.findIndex(x => x.documentId == element.documentId);
        this.dataSource.data[index1].isSelected = true;
      } else {
        var index1 = this.dataSource.data.findIndex(x => x.documentId == element.documentId);
        this.dataSource.data[index1].isSelected = true;
      }
    } else {
      var index1 = this.dataSource.data.findIndex(x => x.documentId == element.documentId);
      this.dataSource.data[index1].isSelected = false;
    }
    var seletlist = this.dataSource.data.filter(x => x.isSelected == true);
    if (seletlist.length == this.originalArry.length) {
      this.mainincompletecheck = true;
    } else {
      this.mainincompletecheck = false;
    }
    this.isDelbtnDisabled = seletlist.length > 0 ? false : true;
    this.selectedEncounters = seletlist;
  }
  CloseDocument() {
    this.dialogRef.close();
  }
}

